import React, {useState} from "react";
import {serverRequest} from "../../../util/server_request";
import {notifyUser} from "../../../util/util";
import { useNavigate } from "react-router-dom";
import {Spin} from "antd";

export const EmployeeNumber = () => {
    const navigate = useNavigate();

    const [employerNumber, setEmployerNumber] = useState('')
    const [loading, setLoading] = useState(false)

    const toggleLoading = () => setLoading(prevState => !prevState)

    const verifyEmployerNumber = () => {
        if (employerNumber === '' || employerNumber === null){
            return notifyUser('error', 'Please enter employer number to proceed!', 'Validation Error');
        }
        toggleLoading();
        serverRequest('POST', 'auth/corporate/verify/employer-number', {employerNumber})
            .then(result => {
                toggleLoading();
                if (result?.code === '200'){
                    notifyUser('success', result.message, 'Success');
                    // Go to OTP page, let user enter OTP sent to their phone
                    navigate('/onboard/one-time-password', { state: { phone: result?.data?.phone, employerNumber } });
                } else {
                    notifyUser('error', result.message, 'Error');
                }
            }).catch(error => {
                toggleLoading();
                notifyUser('error', error.message, 'Error');
            });
    }

    return (
        <div className='mx-auto mobile-full-width shadow bg-white p-5 rounded login-width'>
            <div align='center'>
                <p className='lead fw-bold'>Let’s setup your profile</p>
                <Spin spinning={loading}>
                    <div className="mt-4 w-75 mx-auto mobile-full-width">
                        <div className="mb-5">
                            <omk-text-field label="Employer Number" value={employerNumber} type='text'
                                            onInput={e => setEmployerNumber(e.target.value)}/>
                        </div>
                        <p className="text-center omk-text-small fw-bold">Need help?</p>
                        <p className="text-center omk-text-small text-black-50"><i className="bi bi-shield-lock"/> Your
                            information is confidential and secure</p>

                        <button className="btn btn-primary mb-4 w-50 mobile-full-width"
                                onClick={verifyEmployerNumber}>Continue
                        </button>
                    </div>
                </Spin>
            </div>
        </div>
    )
}